export default "__VITE_ASSET__BYzZbrEB__"